/**
 * Documentación de función según plantilla de 12 apartados (manual de usuario).
 * @param {object} p
 */
export function functionDoc(p) {
  const arr = (v) => (Array.isArray(v) ? v : v ? [v] : []);
  return {
    kind: 'function',
    docVersion: 2,
    id: p.id,
    title: p.name,
    name: p.name,
    functionType: p.type || 'form',
    route: p.route,
    locationPath: p.locationPath || '',
    purpose: p.generalDescription || '',
    generalDescription: p.generalDescription || '',
    prerequisites: arr(p.prerequisites),
    interfaceElements: p.interfaceElements || [],
    procedure: arr(p.procedure),
    practicalExample: p.practicalExample || null,
    validations: arr(p.validations),
    expectedResult: arr(p.expectedResult),
    commonErrors: p.commonErrors || [],
    relatedFunctions: arr(p.relatedFunctions),
    observations: arr(p.observations),
    screenshots: p.screenshots || [],
    roles: p.roles || null,
    isVisible: p.isVisible,
    // compatibilidad vista anterior
    description: arr(p.generalDescription),
    steps: arr(p.procedure),
    fields: (p.interfaceElements || []).map((el) => ({
      name: el.name,
      description: el.description,
      required: el.required,
      validation: el.behavior || el.validation,
      example: el.example,
    })),
    notes: arr(p.observations),
  };
}

/** @deprecated Use functionDoc — mantiene compatibilidad al migrar módulos. */
export function legacyToFunction(section) {
  if (section.docVersion === 2) return section;
  return functionDoc({
    id: section.id,
    name: section.title,
    type: section.kind === 'report' ? 'report' : section.kind === 'screen' ? 'screen' : 'form',
    route: section.route,
    locationPath: section.locationPath || '',
    generalDescription: [section.purpose, ...(section.description || [])].filter(Boolean).join(' '),
    procedure: section.steps || [],
    interfaceElements: (section.fields || []).map((f) => ({
      name: f.name,
      controlType: 'Campo',
      required: f.required,
      editable: true,
      automatic: false,
      description: f.description,
      behavior: f.validation,
      example: f.example,
    })),
    validations: section.kind === 'report' ? section.filters : [],
    expectedResult: section.kind === 'report' ? section.output : [],
    observations: section.notes || [],
    isVisible: section.isVisible,
  });
}
